import { A as emberA } from '@ember/array';
import Model, { attr, belongsTo, hasMany } from '@ember-data/model';

export default class EnvironmentModel extends Model {
  @belongsTo('practice', { async: false, inverse: null }) currentPractice;
  @belongsTo('client-access', { async: false, inverse: null }) currentClientAccess;
  @belongsTo('treatable-client', { polymorphic: true, async: false, inverse: null }) currentClient;
  @hasMany('treatable-client', { polymorphic: true, async: false, inverse: null })
  currentClientOptions;
  @attr() messagingEmbed;

  static fieldsFor(_context) {
    let fields = emberA();
    this.fields.forEach((_, v) => fields.pushObject(v));
    fields.removeObject('meta');
    return fields;
  }
}
